let store;

const setStore = _store => {
    store = _store;
};

const getStore = () => store;

const getState = () => store.getState();
const dispatch = action => store.dispatch(action);
const subscribe = callback => store.subscribe(callback);

export { setStore, getStore, dispatch, getState, subscribe };
